import { Box, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const MultiSelectChipCard = ({
  chipValue,
  theme,
  isDisabled,
  handleChange,
  value,
}) => {
  return (
    <Grid item>
      <Box
        sx={{
          border: `1px solid ${theme.palette.secondary.main}`,

          padding: `${theme.size[4]} ${theme.size[8]}`,
          borderRadius: theme.size[4],
          display: "flex",
          alignItems: "center",
          marginRight: isDisabled ? theme.size[8] : "0px",
          marginBottom: isDisabled ? theme.size[8] : "0px",
        }}
      >
        <div
          style={{
            fontSize: theme.size[12],
            fontWeight: theme.fontWeight[400],
            color: theme.palette.rapidInfra.text,
          }}
        >
          {chipValue}
        </div>

        {!isDisabled ? (
          <CloseIcon
            sx={{
              fontSize: theme.size[16],
              marginLeft: theme.size[4],
              cursor: "pointer",
              color: theme.palette.rapidInfra.text,
              fontWeight: theme.fontWeight[600],
            }}
            onClick={() => {
              handleChange(chipValue, value);
            }}
          />
        ) : null}
      </Box>
    </Grid>
  );
};
